import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/crmApi";
import { PageHeader, Loader } from "@/crm/ui";
import { toast } from "sonner";
import { CheckSquare, Clock, CalendarClock, AlertTriangle } from "lucide-react";

const BUCKETS = [
  { key: "overdue", label: "En retard", icon: AlertTriangle, color: "text-rose-600 bg-rose-50" },
  { key: "today", label: "Aujourd'hui", icon: Clock, color: "text-amber-600 bg-amber-50" },
  { key: "upcoming", label: "À venir", icon: CalendarClock, color: "text-indigo-600 bg-indigo-50" },
];

export default function Tasks() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(null);

  const load = () => api.get("/tasks").then(({ data }) => setTasks(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (t) => { await api.put(`/tasks/${t.id}`, { status: t.status === "done" ? "pending" : "done" }); load(); };

  if (!tasks) return <Loader />;
  const grouped = { overdue: [], today: [], upcoming: [], done: [] };
  tasks.forEach((t) => grouped[t.bucket]?.push(t));

  return (
    <div>
      <PageHeader title="Tâches & relances" subtitle={`${tasks.filter((t) => t.status !== "done").length} tâche(s) en cours`} />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {BUCKETS.map((b) => (
          <div key={b.key} className="bg-white rounded-xl border border-slate-200 p-4" data-testid={`task-bucket-${b.key}`}>
            <div className={`flex items-center gap-2 mb-3 font-heading font-semibold ${b.color.split(" ")[0]}`}>
              <b.icon size={17} /> {b.label} <span className="text-xs bg-slate-100 rounded-full px-2 text-slate-500 ml-auto font-mono">{grouped[b.key].length}</span>
            </div>
            <div className="space-y-2">
              {grouped[b.key].length === 0 ? <p className="text-sm text-slate-400 py-4 text-center">Rien à faire</p> : grouped[b.key].map((t) => (
                <div key={t.id} className="flex items-start gap-2 p-2.5 rounded-lg border border-slate-100 hover:bg-slate-50" data-testid={`task-${t.id}`}>
                  <input type="checkbox" checked={t.status === "done"} onChange={() => toggle(t)} className="mt-0.5" data-testid={`task-check-${t.id}`} />
                  <div className="flex-1 min-w-0 cursor-pointer" onClick={() => t.company_id && navigate(`/entreprises/${t.company_id}`)}>
                    <div className="text-sm text-slate-800">{t.title}</div>
                    <div className="text-xs text-slate-400">{t.company_name || ""} · {t.due_date ? new Date(t.due_date).toLocaleDateString("fr-FR") : ""}</div>
                  </div>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded ${t.priority === "high" ? "bg-rose-100 text-rose-600" : t.priority === "medium" ? "bg-amber-100 text-amber-600" : "bg-slate-100 text-slate-500"}`}>{t.priority}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
